import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useHttpClient } from '../../../../utils/clients/rest-client';
import {
  GenericInputSetInputTypeData,
  GenericInputSetInputTypeError,
  GenericInputSetInputTypesBatchData,
  GenericInputSetInputTypesBatchError,
  SetInputTypeRequest,
  SetInputTypesBatchRequest,
} from '../../types/openapi/openapi-types';

export const useSetInputType = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<
    AxiosResponse<GenericInputSetInputTypeData>,
    AxiosError<GenericInputSetInputTypeError>,
    SetInputTypeRequest
  >(['genericInput-setInputType'], async (body) => await httpClient.genericInput.genericInputSetInputType(body), {
    onError: (error) => {
      handleRestErrors(error);
    },
  });
};

export const useSetInputTypesBatch = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<
    AxiosResponse<GenericInputSetInputTypesBatchData>,
    AxiosError<GenericInputSetInputTypesBatchError>,
    SetInputTypesBatchRequest
  >(
    ['genericInput-setInputTypesBatch'],
    async (body) => await httpClient.genericInput.genericInputSetInputTypesBatch(body),
    {
      onError: (error) => {
        handleRestErrors(error);
      },
    },
  );
};
